var BUSINESS_TYPE;
(function (BUSINESS_TYPE) {
    // 文本
    BUSINESS_TYPE["TEXT"] = "text";
    // 批量文本
    BUSINESS_TYPE["TEXT_BATCH"] = "text_batch";
    // 图片
    BUSINESS_TYPE["IMAGE"] = "image";
    // 昵称
    BUSINESS_TYPE["USER_PF_TEXT"] = "user_pf_text";
    // 批量昵称
    BUSINESS_TYPE["USER_PF_TEXT_BATCH"] = "user_pf_text_batch";
    // 二维码
    BUSINESS_TYPE["IMAGE_WX_QR_CODE"] = "image_wx_qr_code";
})(BUSINESS_TYPE || (BUSINESS_TYPE = {}));

export { BUSINESS_TYPE };
